// ========= START: src/character_db.js (Complete File) =========

export const characters = [
  // --- FEMALE CHARACTERS ---
  {
    id: 1,
    name: 'Sarah',
    voice: 'FEMALE_SARAH',
    profileVideo: `${process.env.PUBLIC_URL}/assets/avatar-1/avatar-1-profile.mp4`,
    idleVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/idle-8.mp4`
    ],
    talkingVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-1/talking-8.mp4`
    ],
  },
  {
    id: 2,
    name: 'Emily',
    voice: 'FEMALE_EMILY',
    profileVideo: `${process.env.PUBLIC_URL}/assets/avatar-2/avatar-2-profile.mp4`,
    idleVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/idle-8.mp4`
    ],
    talkingVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-2/talking-8.mp4`
    ],
  },
  {
    id: 3,
    name: 'Jessica',
    voice: 'FEMALE_JESSICA',
    profileVideo: `${process.env.PUBLIC_URL}/assets/avatar-3/avatar-3-profile.mp4`,
    idleVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/idle-8.mp4`
    ],
    talkingVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-3/talking-8.mp4`
    ],
  },
  // --- MALE CHARACTERS ---
  {
    id: 4,
    name: 'Joseph',
    voice: 'MALE_JOSEPH',
    profileVideo: `${process.env.PUBLIC_URL}/assets/avatar-4/avatar-4-profile.mp4`,
    idleVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/idle-8.mp4`
    ],
    talkingVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-4/talking-8.mp4`
    ],
  },
  {
    id: 5,
    name: 'Aaron',
    voice: 'MALE_AARON',
    profileVideo: `${process.env.PUBLIC_URL}/assets/avatar-5/avatar-5-profile.mp4`,
    idleVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/idle-8.mp4`
    ],
    talkingVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-5/talking-8.mp4`
    ],
  },
  {
    id: 6,
    name: 'Ivan',
    voice: 'MALE_IVAN',
    profileVideo: `${process.env.PUBLIC_URL}/assets/avatar-6/avatar-6-profile.mp4`,
    idleVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/idle-8.mp4`
    ],
    talkingVideos: [
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-1.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-2.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-3.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-4.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-5.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-6.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-7.mp4`,
      `${process.env.PUBLIC_URL}/assets/avatar-6/talking-8.mp4`
    ],
  },
];

// ========= END: src/character_db.js (Complete File) =========